export class API {
  static async createBooking(formData) {
    const response = await fetch("/api/bookings", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });
    return await response.json();
  }

  static async updateBooking(bookingId, formData) {
    const response = await fetch(`/api/bookings/${bookingId}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });
    return await response.json();
  }

  static async getBooking(bookingId) {
    const response = await fetch(`/api/bookings/${bookingId}`);
    return await response.json();
  }

  static async getBookings(date) {
    const response = await fetch(`/api/bookings?date=${date}`);
    return await response.json();
  }

  static async getBookingDates(month, year) {
    const response = await fetch(
      `/api/booking-dates?month=${month}&year=${year}`
    );
    return await response.json();
  }

  static async getAvailableSlots(date, boat, bookingId) {
    if (!date || !boat) return null;

    const response = await fetch(
      `/api/available-slots?date=${date}&boat=${boat}${
        bookingId ? `&bookingId=${bookingId}` : ""
      }`
    );
    return await response.json();
  }
  
  static async getBlocks(date) {
    const response = await fetch(`/api/blocks/${date}`);
    return await response.json();
  }

}
